<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" :disabled="isGeneralLoading"/>
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div ref="value">

              <accessible-el-select
                prop="value"
                v-model="form.value"
                allowCreate
                maxlength='100'
                placeholder="Seleccionar"
                :options="form.ListaBlancaEmails.map((x, index) => ({ id: index, value: x, name: x }))"
                id-prefix="inputtextmailfromwhitelistsimpledialog"
              >
                <template #label>
                  <div class="flex items-center">
                    {{headerValue}}
                    <base-tooltip-icon size="sm" :content="'Seleccione emails de la lista o escriba un nuevo email y selecciónelo'" class="ml-2"/>
                  </div>
                </template>
              </accessible-el-select>
              
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" :disabled="isGeneralLoading || notSelectedMail" :loading="isGeneralLoading"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { email as emailRegex } from '@/utils/regex'
import BaseDialogButton from './base/BaseDialogButton.vue'

import { i18n } from '@/i18n'

import { getWhiteListEmailsMix } from '@/services/clients/lists/getWhiteListEmailsMix'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'input-text-mail-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    headerValue: {
      type: String,
      default: 'Valor'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idNEO: {
      type: [Number, String],
      default: -1
    },
    idRegla: {
      type: [Number, String],
      default: -1
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        value: '',
        GestionarListaBlancaGrupos: false,
        ListaBlancaEmails: [],
      },
      rules: {
        value: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.value = ''
      this.form.GestionarListaBlancaGrupos = false
      if (value) this.downloadListwhiteEmail()
    }
  },
  mounted: async function () {
  },
  computed: {
    notSelectedMail () {
      return !this.form.value
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    }
  },
  methods: {
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form)
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    downloadListwhiteEmail: async function () {
      try {
        const params = this.idNEO === -1 
          ? { idRegla: this.idRegla } 
          : { idNEO: this.idNEO }

        const result = await getWhiteListEmailsMix(params)
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.form.ListaBlancaEmails = result.Emails
          this.form.GestionarListaBlancaGrupos = result.GestionarListaBlancaGrupos
        }
      } catch (error) {
        this.doFeedback()
      } finally {
      }
    },
  }
}
</script>
